"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Animate = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var classnames_1 = __importDefault(require("classnames"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var useTimeout_1 = require("../core/utils/useTimeout");
var useStyles = (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    root: {
        transition: t.transitions.create('all'),
        opacity: 0,
        transform: 'translateY(60px)',
        // overflowY: 'hidden',
    },
    root_appeared: {
        opacity: 1,
        transform: 'translateY(0)',
    },
}); });
var Animate = function (_a) {
    var children = _a.children, delay = _a.delay;
    var _b = (0, react_1.useState)(false), appeared = _b[0], setAppeared = _b[1];
    var classes = useStyles();
    (0, useTimeout_1.useTimeout)(function () { return setAppeared(true); }, delay || 0);
    return React.cloneElement(children, {
        className: (0, classnames_1.default)(classes.root, appeared && classes.root_appeared)
    });
};
exports.Animate = Animate;
//# sourceMappingURL=Animate.js.map